import { useEffect, useMemo } from 'react';
import { useEffectOnce } from 'react-use';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction, MainMenuTabs } from '~/shared';
import { FAQ } from '../../components/FAQ';
import { HeadMenu } from '../../components/HeadMenu';
import { Inventory } from '../../components/Inventory';
import { Main } from '../../components/Main';
import { Modals } from '../../components/Modals';
import { QuestTab } from '../../components/QuestTab';
import { ReportTab } from '../../components/ReportTab';
import { Shop } from '../../components/Shop';
import { Stats } from '../../components/Stats';
import { useMenuLocked } from '../../hooks';
import {
	resetInventoryState,
	resetModalState,
	resetShopState,
	setActiveReportId,
	setIsOpeningCase,
	setReportVisible,
	setTabIndex,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { StyledContainer, StyledMainContainer } from './MainMenu.styled';

const tabs = [
	{
		name: MainMenuTabs.Main,
		component: Main,
	},
	{
		name: MainMenuTabs.Shop,
		component: Shop,
	},
	{
		name: MainMenuTabs.Inventory,
		component: Inventory,
	},
	{
		name: MainMenuTabs.QuestTab,
		component: QuestTab,
	},
	{
		name: MainMenuTabs.Stats,
		component: Stats,
	},
	{
		name: MainMenuTabs.FAQ,
		component: FAQ,
	},
];

const MainMenu = () => {
	const dispatch = useLayoutDispatch();
	const tabIndex = useLayoutSelector((state) => state.mainMenu.tabIndex);
	const ActiveTab = useMemo(() => tabs[tabIndex].component, [tabIndex]);
	const defaultTab = useObservable(rage.game.getDefaultMainMenuTab());
	const reportVisible = useLayoutSelector(
		(state) => state.mainMenu.reportVisible,
	);
	const { closeMenuLocked } = useMenuLocked();

	useEffectOnce(() => {
		return () => {
			dispatch(setTabIndex(0));
			dispatch(resetShopState());
			dispatch(resetInventoryState());
			dispatch(resetModalState());
			dispatch(setReportVisible(false));
			dispatch(setActiveReportId(null));
			dispatch(setIsOpeningCase(false));
			rage.inventory.clearInventories();
		};
	});

	useInputAction(InputAction.CommonMenuClose, () => {
		if (closeMenuLocked) {
			return;
		}

		rage.game.closeMainMenu();
	});

	useEffect(() => {
		if (defaultTab) {
			dispatch(setTabIndex(tabs.findIndex((tab) => tab.name === defaultTab)));
		}
	}, [defaultTab]);

	return (
		<StyledContainer>
			<HeadMenu />
			{reportVisible ? (
				<ReportTab />
			) : (
				<StyledMainContainer>
					<ActiveTab />
				</StyledMainContainer>
			)}
			{/* <InfoBottom /> */}
			<Modals />
		</StyledContainer>
	);
};

export { MainMenu };
